var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart-loader"},[_c('CircleSpinner',{attrs:{"color":"accent"}}),_c('div',{staticClass:"pt-2"},[_vm._v(" "+_vm._s(_vm.loadingText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }